import { HomeSummaryEntity } from "../../domain/entities/HomeSummaryEntity";
import { HomeRepository } from "../../domain/repositories/HomeRepository";
import { HomeApiDataSource } from "../datasources/HomeApiDataSource";
import { HomeSummaryMapper } from "../mappers/HomeSummaryMapper";

export class HomeRepositoryImpl implements HomeRepository {
  constructor(private readonly dataSource: HomeApiDataSource) {}

  async getSummary(signal?: AbortSignal): Promise<HomeSummaryEntity> {
    const dto = await this.dataSource.fetchSummary(signal);

    return HomeSummaryMapper.toDomain(dto);
  }
}
